import { createStyles, Theme } from '@mui/material'

const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    buttonLabel: {
      marginLeft: spacing(),
    },
    button: {
      marginTop: spacing(2),
      display: 'flex',
    },
    addIcon: {
      fill: palette.extra.positive,
    },
  })

export default styles
